import FormControlLabel from "@mui/material/FormControlLabel"
import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"
import CustomCheckbox from "@/components/ui/CustomCheckbox"

export default function MapPanelToggles({ toogleButtonsOnOff, setToogleButtonsOnOff }) {
  const handleChange = (event) => {
    const value = event.target.name
    if (event.target.checked) {
      // Add the checkbox's name to the array if it's checked
      setToogleButtonsOnOff((prevState) => [...prevState, value])
    } else {
      // Remove the checkbox's name from the array if it's unchecked
      setToogleButtonsOnOff((prevState) => prevState.filter((item) => item !== value))
    }
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", p: 0, mt: 0 }}>
        <FormControlLabel
          sx={{ m: 0, width: "100%", justifyContent: "space-between" }}
          control={
            <CustomCheckbox
              checked={toogleButtonsOnOff.includes("Minimap")}
              onChange={handleChange}
              name="Minimap"
              aria-label="minimap"
              color="default"
            />
          }
          label={<Typography sx={{ fontSize: "14px", whiteSpace: "nowrap", color: "#004f7d" }}>Minimap</Typography>}
        />
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", p: 0, mt: 0 }}>
        <FormControlLabel
          sx={{ m: 0, width: "100%", justifyContent: "space-between" }}
          control={
            <CustomCheckbox
              checked={toogleButtonsOnOff.includes("Graticule")}
              onChange={handleChange}
              name="Graticule"
              aria-label="underlined"
              color="default"
            />
          }
          label={<Typography sx={{ fontSize: "14px", whiteSpace: "nowrap", color: "#004f7d" }}>Graticule</Typography>}
        />
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", p: 0, mt: 0 }}>
        <FormControlLabel
          sx={{ m: 0, width: "100%", justifyContent: "space-between" }}
          control={
            <CustomCheckbox
              checked={toogleButtonsOnOff.includes("Terminator")}
              onChange={handleChange}
              name="Terminator"
              aria-label="underlined"
              color="default"
            />
          }
          label={<Typography sx={{ fontSize: "14px", whiteSpace: "nowrap", color: "#004f7d" }}>Daylight</Typography>}
        />
      </Box>
    </Box>
  )
}
